module.exports = __webpack_public_path__ + "img/housing.b3cc415a.png";